import { c as _c } from "react/compiler-runtime";
// The one text button: Clear, Close, Retry, the detail's references and files. Page colour, underlined on hover
// (`underline`: always). Styles: book.css `.link-button`.
import type { ButtonHTMLAttributes } from "react";
export function LinkButton(t0) {
  const $ = _c(10);
  let className;
  let rest;
  let underline;
  if ($[0] !== t0) {
    ({
      className,
      underline,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = underline;
  } else {
    className = $[1];
    rest = $[2];
    underline = $[3];
  }
  const t1 = underline && "underline";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = ["link-button", t1, className].filter(Boolean);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[7] !== rest || $[8] !== t3) {
    t4 = <button type="button" className={t3} {...rest} />;
    $[7] = rest;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}